"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

const KilkayaSpaReady = () => {
  const pathname = usePathname();

  useEffect(() => {
    document.dispatchEvent(new Event("K5A:SpaReady"));
  }, [pathname]);

  return null;
};

export default KilkayaSpaReady;
